import { render } from "./details-panel-placeholder.vue?vue&type=template&id=abfab650&scoped=true&ts=true"
import script from "./details-panel-placeholder.vue?vue&type=script&lang=ts"
export * from "./details-panel-placeholder.vue?vue&type=script&lang=ts"

import "./details-panel-placeholder.vue?vue&type=style&index=0&id=abfab650&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abfab650"]])

export default __exports__